//契約新規登録、編集
export const valueValidation = (value: string | number, name: string) => {
  switch (name) {
    case 'keiyakuNo':
      const patKeiNHelplne = /^(0|1)\d{2}(JA|FB|MR|AP|MY|JU|JL|AU|SP|OC|NO|DE)([0-9]{2}[1-9]|[0-9][1-9][0-9]|[1-9][0-9]{2})\d{2}$/g;
      const patKeiOHelplne = /^(0|1)\d{2}(JA|FB|MR|AP|MY|JU|JL|AU|SP|OC|NO|DE)([0-9]{2}[1-9]|[0-9][1-9][0-9]|[1-9][0-9]{2})$/g;
      const patKeiSs = /^S\d{9}$/g
      const patKeiArrow = /^A\d{7}$/g
      const patKeiMss = /^MSS\d{5}$/g
      const patKeiPer = /^\d{8}$/g
      if (value && typeof (value) == 'string') {
        return !(value.match(patKeiNHelplne) || value.match(patKeiOHelplne) || value.match(patKeiSs) || value.match(patKeiArrow) || value.match(patKeiMss) || value.match(patKeiPer))
      } else {
        return true
      }
    case 'orderNo':
      const patOrd = /^\d*$/g;
      if (value && typeof (value) == 'string') {
        return !value.match(patOrd)
      } else {
        return true
      }
    case 'keiyakuDeposit':
    case 'totalPrice':
    case 'incidentDeposit':
    case 'visitCount':
    case 'incidentCount':
    case 'incidentAddCount':
    case 'monthlyPrice':
    case 'monthlyPrice2':
      const patNum = /^\d*$/g
      if (value === '') {
        return false
      } else if (value && typeof (value) == 'string') {
        return !value.match(patNum)
      } else {
        return true
      }
    case 'incidentUsedCount':
      const patNumUsedCount = /^\d+.?\d+$/g
      if (value === '') {
        return false
      } else if (value === '0' || value === '0.0') {
        return false
      } else if (value && typeof (value) == 'string') {
        return !value.match(patNumUsedCount)
      } else {
        return true
      }
    case 'machineSettingZipCd':
    case 'demandZipCd':
      const patZip = /^\d{3}-?\d{4}$/g;
      if (value && typeof (value) == 'string') {
        return !value.match(patZip)
      } else {
        return true
      }
    default:
      return true
  }
}